function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VFormRender from '@/components/form-render/index';
import addDrawer from '../components/addDrawer';
import checkboxDialog from '@/components/develop/checkboxDialog';
import { crudModuleCreateApi, crudModuleUpdateApi, crudModuleDelApi, crudModuleSaveApi, crudModuleInfoApi, crudModuleListApi, crudModuleFindApi, crudViewSaveApi } from '@/api/develop';
import { fileLinkDownLoad } from '@/libs/public';
export default {
  components: {
    VFormRender: VFormRender,
    checkboxDialog: checkboxDialog,
    addDrawer: addDrawer
  },
  props: {
    keyName: {
      type: String,
      default: ''
    },
    crud_id: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      drawer: false,
      tabIndex: '1',
      importTemplate: {
        formConfig: {},
        widgetList: []
      },
      name: '',
      tabKey: '',
      tabInfo: '',
      tabSave: 'tab',
      title: '',
      type: 'check',
      allocation: {
        association_table: []
      },
      crud: {
        crud_id: 0,
        crud_value: 0
      },
      where: {
        page: 1,
        limit: 15,
        crud_value: 0,
        crud_id: 0,
        keyword_default: ''
      },
      total: 0,
      id: 0,
      // 当前列表的id值
      dropdownList: [],
      tabData: [],
      tableData: []
    };
  },
  created: function created() {
    this.createForm();
  },
  mounted: function mounted() {},
  computed: {
    getName: function getName() {
      var _this = this;
      var str = '';
      this.tabData.map(function (item) {
        if (_this.tabIndex == item.table_name_en) {
          str = item.table_name;
        }
      });
      return str || '';
    }
  },
  watch: {
    info: {
      handler: function handler(val, oldVal) {
        if (val.crudInfo && val.crudInfo.id) {
          this.crud.crud_id = val.crudInfo.id;
          this.where.crud_id = val.crudInfo.id;
        }
        if (val.userOptions) {
          this.dropdownList = val.userOptions.options ? val.userOptions.options.create : [];
          this.tabData = val.userOptions.options ? val.userOptions.options.tab : [];
        }
      },
      deep: true
    }
  },
  methods: {
    addData: function addData() {
      this.$refs.addDrawer.openBox();
    },
    // 数组转成字符串
    getValue: function getValue(val) {
      var str = '';
      if (val == '') {
        str = '--';
      } else if (Array.isArray(val)) {
        str = val.toString();
      } else {
        str = val;
      }
      return str || '--';
    },
    normalizeCrudFiles: function normalizeCrudFiles(val) {
      if (!val) return [];
      var data = val;
      if (typeof data === 'string') {
        var s = data.trim();
        if (!s || s === '[]' || s === 'null') return [];
        try {
          data = JSON.parse(s);
        } catch (e) {
          return s.indexOf('http') === 0 || s.indexOf('/') === 0 ? [{
            url: s,
            name: '下载文件'
          }] : [];
        }
      }
      if (!Array.isArray(data)) {
        data = [data];
      }
      return data.filter(function (item) {
        return item && (item.url || item.file_url || item.att_dir || item.satt_dir);
      });
    },
    downloadCrudFile: function downloadCrudFile(val) {
      var files = this.normalizeCrudFiles(Array.isArray(val) || typeof val === 'string' ? val : [val]);
      var item = files[0] || val;
      if (!item) return;
      var url = item.url || item.file_url || item.att_dir || item.satt_dir || '';
      var name = item.name || item.real_name || '下载文件';
      if (!url) {
        this.$message.error('文件地址无效');
        return;
      }
      fileLinkDownLoad(url, name);
    },
    dropdownSearch: function dropdownSearch(item) {
      var _this2 = this;
      this.tabKey = item.table_name_en;
      setTimeout(function () {
        _this2.$refs.addDrawer.openBox();
      }, 300);
    },
    handleClick: function handleClick(e) {
      var _this3 = this;
      if (e.index != 0) {
        var index = e.index - 1;
        this.tabKey = this.tabIndex;
        this.getInfo();
        this.getList();
      }
      if (this.tabIndex == 1) {
        this.type = 'add';
        this.$nextTick(function () {
          _this3.$refs.preForm.setReadMode(true);
        });
      }
    },
    getInfo: function getInfo() {
      var _this4 = this;
      crudModuleInfoApi(this.tabKey, 0).then(function (res) {
        _this4.tabInfo = res.data;
      });
    },
    getList: function getList() {
      var _this5 = this;
      this.where.crud_value = this.crud.crud_value;
      crudModuleListApi(this.tabKey, this.where).then(function (res) {
        _this5.total = res.data.count;
        _this5.tableData = res.data.list;
      });
    },
    openCheck: function openCheck(type) {
      var selectList = [];
      var ids = [];
      if (type === 'tab') {
        this.tabSave = 'tab';
        this.title = '配置tab显示项';
        if (this.tabData && this.tabData.length > 0) {
          selectList = this.tabData;
          this.tabData.map(function (item) {
            ids.push(item.id);
          });
        } else {
          ids = [];
        }
      } else {
        this.tabSave = 'create';
        this.title = '配置新增按钮';
        if (this.dropdownList && this.dropdownList.length > 0) {
          selectList = this.dropdownList;
          this.dropdownList.map(function (item) {
            ids.push(item.id);
          });
        } else {
          ids = [];
        }
      }
      this.allocation.association_table.forEach(function (item) {
        item.field_name = item.table_name;
      });
      var obj = {
        list: this.allocation.association_table,
        ids: ids,
        selectList: selectList
      };
      this.$refs.checkboxDialog.openBox(obj, ids);
    },
    openBox: function openBox(row, data, info, name) {
      var _this6 = this;
      this.name = name;
      if (info) {
        if (info.crudInfo && info.crudInfo.id) {
          this.crud.crud_id = info.crudInfo.id;
          this.where.crud_id = info.crudInfo.id;
        }
        if (info.userOptions) {
          this.dropdownList = info.userOptions.options ? info.userOptions.options.create : [];
          this.tabData = info.userOptions.options ? info.userOptions.options.tab : [];
        }
      }
      this.id = row.id;
      this.createForm(this.id);
      this.where.crud_value = row.id;
      this.crud.crud_value = this.id;
      if (data) {
        this.allocation = data;
      }
      this.drawer = true;
      setTimeout(function () {
        _this6.setForm();
      }, 300);
    },
    createForm: function createForm(id) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var obj, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              obj = {
                id: id
              };
              _context.next = 3;
              return crudModuleCreateApi(_this7.keyName, obj);
            case 3:
              res = _context.sent;
              _this7.$nextTick(function () {
                if (res.data.form_info.global_options) {
                  _this7.$set(_this7.importTemplate, 'formConfig', res.data.form_info.global_options);
                }
                _this7.$set(_this7.importTemplate, 'widgetList', res.data.form_info.options || []);
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClose: function handleClose() {
      this.tabIndex = '1';
      this.drawer = false;
    },
    getData: function getData(data) {
      var _this8 = this;
      var obj = {};
      if (this.tabSave === 'create') {
        obj.options = {
          create: data.selectList
        };
      } else {
        obj.options = {
          tab: data.selectList
        };
      }
      if (this.crud_id > 0) {
        crudViewSaveApi(this.crud_id, obj).then(function (res) {
          _this8.$emit('getInfo');
        });
      } else {
        crudModuleSaveApi(this.keyName, obj).then(function (res) {
          _this8.$emit('getInfo');
        });
      }
    },
    deleteRow: function deleteRow() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this9.$modalSure('您确认要删除吗');
            case 2:
              _context2.next = 4;
              return crudModuleDelApi(_this9.keyName, _this9.id);
            case 4:
              _context2.next = 6;
              return _this9.$emit('getList');
            case 6:
              _context2.next = 8;
              return _this9.handleClose();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    editRow: function editRow() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this10.tabIndex = '1';
              _this10.$refs.preForm.setReadMode(false);
              _this10.type = 'edit';
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    editTabsRow: function editTabsRow(item) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return crudModuleFindApi(_this11.tabKey, item.id);
            case 2:
              data = _context4.sent;
              _context4.next = 5;
              return _this11.$refs.addDrawer.openBox(item.id, data.data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    deleteTabsRow: function deleteTabsRow(item) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this12.$modalSure('您确认要删除吗');
            case 2:
              _context5.next = 4;
              return crudModuleDelApi(_this12.tabKey, item.id);
            case 4:
              _context5.next = 6;
              return _this12.getList();
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    saveFn: function saveFn() {
      var _this13 = this;
      this.$refs['preForm'].getFormData().then(function (formData) {
        if (_this13.id > 0) {
          _this13.upladData(_this13.id, formData);
        }
      }).catch(function (error) {
        _this13.$message.error(error);
      });
    },
    upladData: function upladData(id, data) {
      var _this14 = this;
      this.loading = true;
      crudModuleUpdateApi(this.keyName, id, data).then(function (res) {
        _this14.loading = false;
        _this14.type = 'check';
        _this14.setForm();
      }).catch(function (err) {
        _this14.loading = false;
      });
    },
    setForm: function setForm() {
      this.type = 'check';
      this.$refs.preForm.setReadMode(true);
    }
  }
};